import React, { Component, createRef } from 'react';
import classnames from 'classnames';
import { waitElementReady } from '../util';

class TimeSelector extends Component {
    wrapper = createRef(null);
    liRefs = new Map();

    componentDidMount() {
        this.initScroll();      
    }
    
    componentDidUpdate(prevProps) {
        let { value, open } = this.props;
        if (value !== prevProps.value || open !== prevProps.open) {
            this.initScroll();
        }
    }

    componentWillUnmount() {
        this.raf?.();
    }

    initScroll () {
        let { value, open } = this.props;
        let li = this.liRefs.get(value);
        if (li && open) {
            this.raf?.();
            this.raf = waitElementReady(li, () => {
                this.scrollTo(li.offsetTop);
            });
        }
    }

    scrollTo = (to, duration = 120) => {
        let wrapper = this.wrapper.current;
        if (wrapper) {
            let scrollTop = wrapper.scrollTop;
            if (duration <= 0) {
                wrapper.scrollTop = to;
                return;
            }
            const difference = to - scrollTop;
            const perTick = (difference / duration) * 10;
            requestAnimationFrame(() => {
                wrapper.scrollTop += perTick;
                if (wrapper.scrollTop !== to) {
                    this.scrollTo(to, duration - 10);
                }
            });
        }
    }

    render() {
        let { value, itemCount, onSelect, disabled } = this.props;
        return <div className="time-selector-wrapper" ref={this.wrapper}>
            <ul>
                {[...new Array(itemCount)].map((_, i) => {
                    if (i < 10) {
                        i = '0' + i;
                    }
                    i = String(i);
                    return <li 
                        ref={element => {
                            this.liRefs.set(Number(i), element);
                        }}
                        key={i} 
                        className={classnames({ "selected": value === Number(i), 'disabled-time': disabled?.length === 2 && i >= disabled[0] && i <= disabled[1] })}
                        onClick={event => {
                            onSelect?.(i);
                            this.scrollTo(event.target.offsetTop);
                        }}
                    >{i}</li>;  
                })}
            </ul>
        </div>;
    }
}

class TimePanel extends Component {
    constructor (props) {
        super(props);
        this.state = {};
    }

    render () {
        let { value, onSelect, open, showHour = true, showSecond = true, showMinute = true, panelWrapperProps, disabledTime } = this.props;
        let currentHour = -1,
            currentMinutes = -1,
            currentSeconds = -1;

        if (!(value instanceof Date)) {
            value = new Date();
            value.setHours(0);
            value.setMinutes(0);
            value.setSeconds(0);
        } else {
            currentHour = value.getHours(),
            currentMinutes = value.getMinutes(),
            currentSeconds = value.getSeconds();
        }

        let disabledHours = [], disabledMinutes = [], disabledSeconds = [];
        if(typeof disabledTime === 'function'){
            let disableTimes = disabledTime(value);
            disabledHours = disableTimes.disabledHours ?? [];
            disabledMinutes = disableTimes.disabledMinutes ?? [];
            disabledSeconds = disableTimes.disabledSeconds ?? [];
        }

        return <div
            className={classnames({
                "picker-panel-content": true,
                "picker-time-panel": true,
            })}
            {...panelWrapperProps}
        >
            <div className="picker-panel-header">
                {currentHour > -1 && currentMinutes > -1 && currentSeconds > -1 && <span>
                    {currentHour < 10 ? '0' + currentHour : currentHour}:
                    {currentMinutes < 10 ? '0' + currentMinutes : currentMinutes}:
                    {currentSeconds < 10 ? '0' + currentSeconds : currentSeconds}
                </span>}
            </div>
            <div className="picker-time-selector">
                {/* 时 */}
                { 
                    showHour && <TimeSelector open={open} disabled={disabledHours} itemCount={24} value={currentHour} onSelect={hour => {
                        let date = new Date(value);
                        date.setHours(hour);
                        onSelect?.(date, 'time');
                    }} />
                }
                {/* 分 */}
                {
                    showMinute && <TimeSelector open={open} disabled={disabledMinutes} itemCount={60} value={currentMinutes} onSelect={minute => {
                        let date = new Date(value);
                        date.setMinutes(minute);
                        onSelect?.(date, 'time');
                    }} />
                }
                {/* 秒 */}
                {
                    showSecond && <TimeSelector open={open} disabled={disabledSeconds} itemCount={60} value={currentSeconds} onSelect={seconds => {
                        let date = new Date(value);
                        date.setSeconds(seconds);
                        onSelect?.(date, 'time');
                    }} />
                }
            </div>
        </div>;
    }
}

export default TimePanel;
